import * as React from "react";
import classnames from "classnames";
import CardIcon from "./CardIcon.js";
/* empty css                 */
const CardContent = ({
  children,
  variant = "normal",
  center,
  className,
  childrenWrapperClassName,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames("card-content", `card-content--${variant}`, className, {
      "card-content--center": center
    }),
    ...rest
  },
  /* @__PURE__ */ React.createElement("div", { className: childrenWrapperClassName }, children),
  variant === "link" ? /* @__PURE__ */ React.createElement(CardIcon, { name: "chevron-right", className: "card-content__link-icon" }) : null
);
export {
  CardContent as default
};
//# sourceMappingURL=CardContent.js.map
